import React from 'react'

const FieldLoader = ({ label = "Loading..." }) => {
    return (
        <div className="w-full">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <div className="h-10 w-full rounded-md bg-gradient-to-r from-indigo-50 to-blue-50 flex items-center justify-center border border-indigo-100">
                <div className="flex gap-1.5">
                    <div className="w-1.5 h-1.5 bg-indigo-400 rounded-full animate-bounce [animation-delay:0ms]" />
                    <div className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-bounce [animation-delay:150ms]" />
                    <div className="w-1.5 h-1.5 bg-sky-400 rounded-full animate-bounce [animation-delay:300ms]" />
                </div>
            </div>
        </div>
    )
}

export default FieldLoader;